import { apiRoutes } from ".";
import { callApi } from "./caller";

export default class AuthService {
    
    static async loginGoogle(data, req = {
        cancelToken: undefined,
        signal: undefined
    }) {
        return await callApi({
            method: 'put',
            path: apiRoutes.auth.google_login,
            cancelToken: req.cancelToken,
            signal: req.signal,
            payload: data
        });
    }

    static async me(req = {
        cancelToken: undefined,
        signal: undefined
    }) {
        return await callApi({
            method: 'get',
            path: apiRoutes.auth.me,
            cancelToken: req.cancelToken,
            signal: req.signal
        });
    }

    static async ask(data, req = {
        cancelToken: undefined,
        signal: undefined
    }) {
        return await callApi({
            method: 'post',
            path: apiRoutes.ask,
            cancelToken: req.cancelToken,
            signal: req.signal,
            payload: data
        });
    }

    static async joinNewsletter(data, req = {
        cancelToken: undefined,
        signal: undefined
    }) {
        return await callApi({
            method: 'post',
            path: apiRoutes.joinNewsletter,
            cancelToken: req.cancelToken,
            signal: req.signal,
            payload: data
        })
    }

    static async sendQuote(data, req = {
        cancelToken: undefined,
        signal: undefined
    }) {
        return await callApi({
            method: 'post',
            path: apiRoutes.sendQuote,
            cancelToken: req.cancelToken,
            signal: req.signal,
            payload: data
        })
    }
    
}